import createReducer from 'utils/redux/createReducer'

const initialState = window.innerWidth

export default createReducer(initialState, {
	RESIZE: (currentState, action) => action.data
})



// WEBPACK FOOTER //
// ./src/reducers/screenSize.js